import { render } from "./TeamPage.vue?vue&type=template&id=677248c0&scoped=true"
import script from "./TeamPage.vue?vue&type=script&lang=js"
export * from "./TeamPage.vue?vue&type=script&lang=js"

import "./TeamPage.vue?vue&type=style&index=0&id=677248c0&lang=css"
import "./TeamPage.vue?vue&type=style&index=1&id=677248c0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-677248c0"]])

export default __exports__